<template>
    <div class="w-full h-full">
        <div v-text="value"
             v-if="!isEdit"
             :class="classes"
             @dblclick="toggle"
             class="cursor-pointer"
        >
        </div>
        <date-picker :options="{firstDay: 1}"
                     v-if="isEdit"
                     v-model="value"
                     @input="() => {
                        this.isClean = false;
                        this.onBlur(true);
                     }"
                     :class="classes"
                     autofocus
        >

        </date-picker>
    </div>
</template>

<script>
    import EditCell from '../mixins/EditCell';
    import DatePicker from './DatePicker';

    export default {

        mixins: [EditCell],

        components: {DatePicker},

    }
</script>
